import gql from 'graphql-tag';

export const foundationVulnerableProjectsQuery = gql`
  query foundationVulnerableProjects($input: FoundationVulnerabilityInput) {
    foundationVulnerableProjects(input: $input) {
      id
      name
      parent
      updatedAt
      description
      logoUrl
      colorBand
      vulnerability {
        projectId
        sfdcProjectId
        message
        totalRepositories
        totalScannedRepositories
        updatedAt
        securityIssues {
          high {
            totalCount
            fixableCount
          }
          medium {
            totalCount
            fixableCount
          }
          low {
            totalCount
            fixableCount
          }
          total {
            totalCount
            fixableCount
          }
        }
      }
    }
  }
`;
